import { arrayToSimpleObj } from '../utils';

export const channelTypeOptions = [
  { value: 'game store', text: 'Game Store' },
  { value: 'social media', text: 'Social Media' },
  { value: 'stream', text: 'Stream' },
];

export const channelTypeSingleOptions = [
  { value: 'game store', text: 'Game Store' },
  { value: 'social media', text: 'Social Media' },
];

export const channelTypeMap = arrayToSimpleObj(channelTypeOptions);
